import { Card } from '@components/v2/card'
import { LinearProgress } from '@taxonomy-translation/components'
import { PropsWithChildren } from 'react'

export const MetricsCard = ({ children }: PropsWithChildren) => {
  return (
    <Card
      variant="primary"
      className="flex flex-col justify-between rounded-lg min-w-[478px] flex-1"
    >
      {children}
    </Card>
  )
}

const Content = ({ children }: PropsWithChildren) => {
  return <div className="grid grid-rows-2 w-full h-full py-11 px-9">{children}</div>
}

const MetricsCardLinearProgress = ({ progress }: { progress: number }) => {
  return (
    <div className="rounded-bl-lg rounded-br-lg overflow-hidden">
      <LinearProgress progress={progress} />
    </div>
  )
}

MetricsCard.Content = Content
MetricsCard.LinearProgress = MetricsCardLinearProgress
